import { useQueries, useQuery } from '@tanstack/react-query';

import { getPnrDiscoveries, getPnrDiscovery } from '~/services/FlightsService';

export const pnrDiscoveryQueryKeys = {
  all: ['pnr-discoveries'] as const,
  lists: () => [...pnrDiscoveryQueryKeys.all, 'list'] as const,
  list: (filters: Parameters<typeof getPnrDiscoveries>[0]) => [...pnrDiscoveryQueryKeys.lists(), filters] as const,
  detail: (pnr?: string) => [...pnrDiscoveryQueryKeys.all, 'detail', pnr] as const,
};

export function useGetPnrDiscoveries(filters: Parameters<typeof getPnrDiscoveries>[0]) {
  return useQuery({
    queryKey: pnrDiscoveryQueryKeys.list(filters),
    queryFn: ({ signal }) => getPnrDiscoveries(filters, { signal }),
  });
}

export function useGetPnrDiscovery(pnr?: string) {
  return useQuery({
    queryKey: pnrDiscoveryQueryKeys.detail(pnr),
    queryFn: ({ signal }) => getPnrDiscovery(pnr, { signal }),
    enabled: !!pnr,
  });
}

/** Live Sabre booking details of every PNR selected for one import. */
export function useGetPnrDiscoveryDetails(pnrs: Array<string>) {
  return useQueries({
    queries: pnrs.map((pnr) => ({
      queryKey: pnrDiscoveryQueryKeys.detail(pnr),
      queryFn: ({ signal }) => getPnrDiscovery(pnr, { signal }),
    })),
  });
}
